import React, { useState } from 'react';
import Filters from '../../../components/Filter';
import FilterInput from '../../../components/Filter/components/FilterInput';
import { translate } from '../../../services/translate';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { DispatchParamList } from '../../../typings/Params';
import ActingBodiesUnitsDropdown from '../../../components/Dropdowns/ActingBodiesUnitsDropdown';
import ActingBodiesDropdown from '../../../components/Dropdowns/ActingBodiesDropdown';
import { useAuth } from '../../../context/Auth';

interface Props {
    filters: DispatchParamList['UnitFinishEarlyReasons'];
    setFilters: React.Dispatch<React.SetStateAction<DispatchParamList['UnitFinishEarlyReasons']>>;
    textFilter: string;
    setTextFilter: (value: string) => void;
}

function Filter({ filters, setFilters, textFilter, setTextFilter }: Props) {
    const { user: authenticatedUser } = useAuth();
    const navigation = useNavigation<NavigationProp<RouteProp<DispatchParamList, 'UnitFinishEarlyReasons'>>>();

    const [actingBodyId, setActingBodyId] = useState<number>(filters.actingBodyId ?? 0);
    const [actingBodyUnitId, setActingBodyUnitId] = useState<number>(filters.actingBodyUnitId ?? 0);

    const handleCleanFilter = () => {
        setTextFilter('');
        setActingBodyId(0);
        setActingBodyUnitId(0);
    };

    const handleFilter = () => {
        navigation.setParams({
            ...filters,
            page: 1,
            textFilter: textFilter !== '' ? textFilter : undefined,
            actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined,
            actingBodyUnitId: actingBodyUnitId !== 0 ? actingBodyUnitId : undefined,
        });

        setFilters({
            ...filters,
            page: 0,
            textFilter: textFilter !== '' ? textFilter : undefined,
            actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined,
            actingBodyUnitId: actingBodyUnitId !== 0 ? actingBodyUnitId : undefined,
        });
    };

    const getActingBodyId = () => {
        if (authenticatedUser?.isAdmin || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_unit_finish_early_reasons) {
            return actingBodyId;
        }
        return authenticatedUser?.actingBodyUnit.actingBodyId ?? 0;
    };

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <FilterInput
                label={translate('typeToSearch')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />

            {(authenticatedUser?.isAdmin ||
                authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_unit_finish_early_reasons) &&
                <ActingBodiesDropdown
                    includeAllOption={true}
                    value={actingBodyId}
                    setValue={setActingBodyId}
                    zIndex={4} />
            }

            {(authenticatedUser?.isAdmin ||
                authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_unit_finish_early_reasons ||
                authenticatedUser?.permissions.dispatch_manage_acting_body_units_unit_finish_early_reasons) &&
                <ActingBodiesUnitsDropdown
                    actingBodyId={getActingBodyId()}
                    value={actingBodyUnitId}
                    setValue={setActingBodyUnitId}
                    zIndex={3} />
            }
        </Filters>
    );
}


export default Filter;
